<main *ngIf="permissionDenied===false" @fade>
  <nb-card [nbSpinner]="loading">
    <nb-card-header>
      <app-create-update-header [model]="this"/>
    </nb-card-header>
    <nb-card-body>
      <div [ngClass]="isModal ? '' : 'row'">
        <div [ngClass]="isModal ? '' : 'col-lg-7 n-part-left'">
          <app-create-update-form [base]="this"/>
        </div>
        <div *ngIf="editMode" class="col-lg-5 n-part-left">
          <app-picture (pictureEvent)="pictureEvent($event)" [entityModel]="model" [pictureField]="pictureField" [uri]="uploadPictureUri"/>

          <app-terms (insertTermEvent)="insertTerm($event)" (removeTermEvent)="removeTerm($event)" [model]="model"/>
        </div>
      </div>
    </nb-card-body>

  </nb-card>
</main>
<main *ngIf="permissionDenied">
  Permission Denied
</main>
